import * as React from 'react'
import { useTheme } from 'styled-components'

interface Props {
  width?: number
  height?: number
  fill?: string
}

const DEFAULT_IMAGE_STYLE: React.CSSProperties = {
  width: '40px',
  height: '40px',
}

export const VoteNotPassedIcon: React.FC<Props> = ({ fill, width, height }) => {
  const defaultFill = useTheme().colors.primary.medium
  const styleWithDefault = {
    fill: fill ?? defaultFill,
    width: width ?? DEFAULT_IMAGE_STYLE.width,
    height: height ?? DEFAULT_IMAGE_STYLE.height,
  }
  return (
    <svg viewBox="0 0 20 20" style={styleWithDefault} xmlns="http://www.w3.org/2000/svg">
      <g id="Not_passed_vote_Cross_icon" transform="translate(-553.534 -577.298)">
        <circle
          id="Ellipse_1406"
          cx="10"
          cy="10"
          r="10"
          fill="rgba(214,75,119,0.1)"
          transform="translate(553.534 577.298)"
        />
        <g id="Group_21041">
          <path
            id="Path_13652"
            d="M563.534 577.3a10 10 0 1 0 10 10 10.012 10.012 0 0 0-10-10zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8z"
          />
          <path
            id="Path_13653"
            d="M566.8 582.529l-3.355 3.354-3.355-3.355-1.414 1.414 3.355 3.355-3.356 3.355 1.414 1.414 3.356-3.355 3.355 3.355 1.414-1.414-3.355-3.355 3.355-3.354z"
          />
        </g>
      </g>
    </svg>
  )
}
